/**
 * Any Dealer-specific javascript can be added here.
 *
 * The OEM theme's JS is all bundled by mix, but if you need to include a
 * import a specific file, '@oem-theme' is an alias to the OEM theme's
 * 'assets/js' folder, and can be referenced like so:
 * import { convertStrToMilitaryTime } from '@oem-theme/utilities.js';
 *
 * For convenience, '@dealer' is an alias to this theme's 'assets/js' folder.
 */

const $ = jQuery;

// Home Hero Slider Video Play Handling
const $homeHeroSlider = $(".home-hero-slider");

// $homeHeroSlider.on("init", function (event, slick) {
//   if ( slick.$slides[0].find('.video-slide').length ) {
//     const $iframe = slick.$slides[0].find('iframe');
//     playIframe($iframe);
//   }
// });

$homeHeroSlider.on('afterChange', function(event, slick, currentSlide){
  const $currentSlideDom = $(slick.$slides.get(currentSlide));
  // slide has video
  if ($currentSlideDom.find('.video-slide').length) {
    const $iframe = $currentSlideDom.find('iframe');
    playIframe($iframe);

  // slide has no video  
  } else {
   slick.$slides.each( function () {
     $(this).find('iframe').each(function () {
       const $iframe = $(this); 
       stopIframe($iframe);
     });
   });
  }
});


function playIframe($iframe) {
  let src =  $iframe.attr('src');
  $iframe.attr('src', src + '&autoplay=1');
}

function stopIframe($iframe) {
  let src =  $iframe.attr('src');
  let newSrc = src.replace('&autoplay=1', '');
  $iframe.attr('src', newSrc);
}